import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M3.029 0a.5.5 0 0 0-.465.316L1.141 4.467A.385.385 0 0 0 1.5 5h1.508a.25.25 0 0 1 .241.315L2.156 9.4A.5.5 0 0 0 3 9.853l5.769-6.411a.385.385 0 0 0-.269-.664H6.48a.25.25 0 0 1-.232-.343l.7-1.749A.5.5 0 0 0 6.484 0Z"
    }, null, -1)
  ]));
}
const imageFlashLightning = { render };
export {
  imageFlashLightning as default,
  render
};
//# sourceMappingURL=image-flash-lightning.svg.js.map
